/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./remove-resource-button.vue?vue&type=template&id=63556e40&"
import script from "./remove-resource-button.vue?vue&type=script&lang=js&"
export * from "./remove-resource-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports